import { Tooltip } from "@/components/ui/tooltip";
import { AppColors } from "@/styles/colors";
import { Text } from "@chakra-ui/react";
import { PenLine } from "lucide-react";
import { ProductEntity } from "../schema/products.schema";

interface Props {
  item: ProductEntity;
  handleEdit: (item: ProductEntity) => void;
}

export const ProductActions = ({ handleEdit, item }: Props) => {
  return (
    <Tooltip
      showArrow
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={
        <Text color={AppColors.WHITE_SECONDARY} fontSize="14px">
          Editar
        </Text>
      }
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <button
        type="button"
        aria-label="Editar"
        data-testid={`"product-button"-${item?.id}`}
        style={{ 
          background: "none", 
          border: "none", 
          cursor: "pointer",
          justifySelf: "flex-end", 
          marginRight: "16px",
          padding: 0,
          display: "flex",
          alignItems: "center"
        }}
        onClick={() => handleEdit(item)}
      >
        <PenLine
          size="20px"
        />
      </button>
    </Tooltip>
  );
};
